module.exports = __webpack_public_path__ + "static/far-cry_contest-64254e64918fe0e0b4701c5c64863ee7.avif";